import { type BaseApiContract } from "shared/api/BaseApiContract";
import { HttpMethod } from "shared/api/http";
import {
  type SocietyDashboardParams,
  type SocietyDashboardModuleViewWithDetails,
} from "shared/api/types/society/[societyId]/dashboards/[dashboardId]";
export const getSocietyDashboardIdContract: BaseApiContract<
  SocietyDashboardParams,
  undefined,
  SocietyDashboardModuleViewWithDetails
> = {
  method: HttpMethod.GET,
  apiRoute: "/api/v1/society/[societyId]/dashboards/[dashboardId]",
  paramsType: {} as SocietyDashboardParams,
  responseType: {} as SocietyDashboardModuleViewWithDetails,
};
